import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { ColorSchemeScript } from '@mantine/core';
import { AppProviders } from './providers/AppProviders';
import App from './App';

// Color scheme script injects the data-mantine-color-scheme attribute before hydration.
document.head.prepend(document.createElement('script'));
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ColorSchemeScriptWrapper />
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
);

function ColorSchemeScriptWrapper() {
  return <ColorSchemeScript defaultColorScheme="auto" />;
}
